export { default } from './TruckBodyStyleCard';
